import axios from "axios";
import API from "../helpers/api";
import {  getOthersMI,getEuMI } from "./MDDetailAPI";
export const postMDData = (data) => {
    let url = `${API.MDPostAPI}`;
    return dispatch => {
        axios.post(url, data).then((response) => {
            dispatch({
                type: 'PostMaterialDeclarationSuccess',
                data: response.data
            })
        }).catch((error) => {
            dispatch({
                type: 'PostMaterialDeclarationFailure',
                data: "error"
            })

        })
    }
}
export const postMIData = (data) => {
    let url = `${API.MIPostAPI}`;
    return dispatch => {
        axios.post(url, data).then((response) => {
            dispatch({
                type: 'PostMaterialInformationSuccess',
                data: response.data
            })
        }).catch((error) => {
            dispatch({
                type: 'PostMaterialInformationFailure',
                data: "error"
            })

        })
    }
}
export const postRDData = (data) => {
    let url = `${API.RDPostAPI}`;
    return dispatch => {
        axios.post(url, data).then((response) => {
            dispatch({
                type: 'PostRelatedDocSuccess',
                data: response.data
            })
        }).catch((error) => {
            dispatch({
                type: 'PostRelatedDocFailure',
                data: "error"
            })

        })
    }
}
export const postMDRemark = (data) => {
    let url = `${API.RemarkPostAPI}`;
    return dispatch => {
        axios.post(url, data).then((response) => {
            dispatch({
                type: 'PostMDRemarkSuccess',
                data: response.data
            })
        }).catch((error) => {
            dispatch({
                type: 'PostMDRemarkFailure',
                data: "error"
            })
        })
    }
}
export const postMI = (data,id) => {
    let url = `${API.MIPostAPI}`;
    return dispatch => {
        axios.post(url, data).then((response) => {
            dispatch(getOthersMI(id));
            dispatch({
                type: 'PostMaterialInformationSuccess',
                data: response.data
            })
        }).catch((error) => {
            dispatch({
                type: 'PostMaterialInformationFailure',
                data: "error"
            })

        })
    }
}
export const postEU = (data,id) => {
    let url = `${API.MIPostAPI}`;
    return dispatch => {
        axios.post(url, data).then((response) => {
            dispatch(getEuMI(id));
            dispatch({
                type: 'PostMaterialInformationSuccess',
                data: response.data
            })
        }).catch((error) => {
            dispatch({
                type: 'PostMaterialInformationFailure',
                data: "error"
            })

        })
    }
}